











































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Locale } from '@/enums/Locale';
import { InputType } from '@/enums/InputType';
import months from '@/data/months';
import { Option } from '@/util/Option';
import { extend } from 'vee-validate';
import { integer } from 'vee-validate/dist/rules';
import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormInput from '@/components/Form/InputComponents/FormInput.vue';
import Validatable from '@/components/Validatable.vue';
import FormSelect from '@/components/Form/InputComponents/FormSelect.vue';
import { User } from '@/util/User';
import { namespace } from 'vuex-class';
import { Store } from '@/enums/Store';
import { Currency } from '@/enums/Currency';
import { Event } from '@/util/Event';

const APP = namespace(Store.APP);
const PAYMENT_INTERVAL = namespace(Store.PAYMENT_INTERVAL);
const EVENT = namespace(Store.EVENT);

@Component({
  components: { FormSelect, FormInput, FormGroup }
})
export default class AdditionalInformationForm extends Validatable {
  @Prop({ required: true }) member!: User;
  @APP.State('storeId') storeId!: number;
  @APP.State('currency') currency!: Currency;
  @PAYMENT_INTERVAL.State('paymentContributionInterval')
  paymentContributionInterval!: string;
  @EVENT.Getter('selectedEventObject') event!: Event;

  @Watch('member', { deep: true })
  updateMember() {
    this.$emit('update:member', this.member);
  }

  TEXT = InputType.TEXT;
  NUMBER = InputType.NUMBER;

  countries!: Option[];
  days: Option[] = [];
  months: Option[] = [];
  years: Option[] = [];
  targetGroup: Option[] = [];
  apprenticeGroup: Option[] = [];
  kFiveStatus: Option[] = [];
  isGermany = false;
  christForum: Option[] = [];

  get hasEventApprenticeOption() {
    return this.hasField('apprentice_option');
  }

  get hasEventK5Status() {
    return this.hasField('k5_status');
  }

  get hasEventK5MemberType() {
    return this.hasField('event_k5_member_type');
  }

  get hasTargetGroup() {
    return this.hasField('target_group');
  }

  get hasYouthName() {
    return this.hasField('youth_name');
  }

  get hasCellPhone() {
    return this.hasField('cell_phone');
  }

  get hasChristForum() {
    return this.hasField('christus_forum');
  }

  hasField($field: string): boolean {
    return this.event.ticketCategories[0].formFields.includes($field);
  }

  created(): void {
    if (this.storeId == 1) {
      this.isGermany = true;
    }

    extend('integer', {
      ...integer,
      message: this.$t('integer-invalid').toString()
    });

    this.countries = [new Option(this.$t('germany').toString(), Locale.DE)];

    for (let i = 1; i <= 31; i++) {
      const option = new Option(i.toString(), i);
      this.days.push(option);
    }

    for (let i = 0; i < 12; i++) {
      const option = new Option(this.$t(months[i]).toString(), i);
      this.months.push(option);
    }

    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 100; i--) {
      const option = new Option(i.toString(), i);
      this.years.push(option);
    }

    this.targetGroup = [
      new Option('Ich bin ein K5 Standorttrainer*', 'Ich bin ein K5 Standorttrainer*'),
      new Option('Ich bin ein K5 Standortmanager* ', 'Ich bin ein K5 Standortmanager*'),
      new Option('Nachwuchsleiter / Sonstige', 'Nachwuchsleiter / Sonstige'),
      new Option(
        'Hauskreis- bzw. Kleingruppenleiter',
        'Hauskreis- bzw. Kleingruppenleiter'
      ),
      new Option(
        'Teamleiter, Bereichsleiter (in Gemeinde oder Beruf)',
        'Teamleiter, Bereichsleiter (in Gemeinde oder Beruf)'
      ),
      new Option(
        'Jugendleiter und Junge Generation',
        'Jugendleiter und Junge Generation'
      ),
      new Option(
        'Pastor, Gemeindeleiter (Hauptberuflich)',
        'Pastor, Gemeindeleiter (Hauptberuflich)'
      ),
      new Option(
        'Unternehmer, Selbstständiger, Führungskraft aus der Wirtschaft',
        'Unternehmer, Selbstständiger, Führungskraft aus der Wirtschaft'
      )
    ];

    this.kFiveStatus = [
      new Option(
        'Ich bin neu beim K5-Leitertraining',
        'Ich bin neu beim K5-Leitertraining'
      ),
      new Option(
        'Ich war schon mal bei ein paar Trainingstagen des K5 Leitertrainings dabei',
        'Ich war schon mal bei ein paar Trainingstagen des K5 Leitertrainings dabei'
      ),
      new Option(
        'Ich habe in der Vergangenheit bereits 12 Trainingstage des K5 Leitertrainings absolviert',
        'Ich habe in der Vergangenheit bereits 12 Trainingstage des K5 Leitertrainings absolviert'
      )
    ];

    this.apprenticeGroup = [
      new Option(
        'Ich fördere einen anderen K5 Teilnehmer (Ich bin Azubi-Trainer)',
        'Ich fördere einen anderen K5 Teilnehmer (Ich bin Azubi-Trainer)'
      ),
      new Option(
        'Ich werde von einem anderen K5 Teilnehmer gefördert (Ich bin ein Azubi)',
        'Ich werde von einem anderen K5 Teilnehmer gefördert (Ich bin ein Azubi)'
      ),
      new Option(
        'Ich melde mich ohne einen Azubi-Partner an',
        'Ich melde mich ohne einen Azubi-Partner an'
      )
    ];

    this.christForum = [new Option('Ja', true), new Option('Nein', false)];
  }

  get hasApprentice() {
    return (
      this.member.apprentice ==
      'Ich fördere einen anderen K5 Teilnehmer (Ich bin Azubi-Trainer)'
    );
  }

  get isApprentice() {
    return (
      this.member.apprentice ==
      'Ich werde von einem anderen K5 Teilnehmer gefördert (Ich bin ein Azubi)'
    );
  }

  get date() {
    if (typeof this.member.dob == 'string') {
      return new Date(this.member.dob);
    }

    if (this.member.dob) {
      return new Date(this.member.dob.getTime());
    }

    return new Date();
  }

  set day(days: number) {
    const date = this.date;
    date.setDate(days);
    this.$set(this.member, 'dob', date);
  }

  get day() {
    return this.date.getDate();
  }

  set month(month: number) {
    const date = this.date;
    date.setMonth(month);
    this.$set(this.member, 'dob', date);
  }

  get month() {
    return this.date.getMonth();
  }

  set year(year: number) {
    const date = this.date;
    date.setFullYear(year);
    this.$set(this.member, 'dob', date);
  }

  get year() {
    return this.date.getFullYear();
  }
}
